<template>
  <v-dialog
    v-model="menu2"
    class="poppins"
    transition="dialog-bottom-transition"
    style="z-index: 33333 !important"
    content-class="d-flex justify-content-center align-items-center elevation-0"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="attrs"
        v-on="on"
        :value="value"
        :label="label"
        clearable
        outlined
        dense
        append-icon="mdi-calendar"
        @click:clear="clearDate"
        @click.prevent="toggleDialog"
      />
    </template>
    <template v-slot:default v-if="menu2 === true">
      <date-range-picker
        ref="picker"
        opens="inline"
        :close-on-esc="false"
        :showDropdowns="true"
        :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd HH:MM:SS' }"
        control-container-class="form-control border-0 bg-transparent d-none"
        single-date-picker
        :ranges="false"
        :timePicker="false"
        class="max-w-275px"
        v-model="date"
        :min-date="minDate"
      >
        <!--    @update="updateDateValue"-->

        <template v-slot:footer="picker">
          <div
            class="drp-buttons py-4 px-6 poppins d-flex justify-content-center align-items-center"
          >
            <div class="d-flex align-center">
              <button
                type="button"
                class="btn btn-light ls1 py-2 px-4"
                @click="
                  () => {
                    picker.clickCancel();
                    menu2 = false;
                  }
                "
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn--print-upload ls1 py-2 px-3"
                @click="
                  () => {
                    picker.clickApply();
                    onChangeDateRange();
                  }
                "
              >
                Apply
              </button>
            </div>
          </div>
        </template>
      </date-range-picker>
    </template>
  </v-dialog>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: "OrderSingleDatePicker",
  components: {
    DateRangePicker,
  },
  props: {
    label: { default: null },
    value: { default: null },
    min: { required: false, default: null },
    clearDate: { type: Function, default: () => {} },
  },
  data: function () {
    let startDate = new Date();
    startDate.setHours(0, 0);
    // let minDate = new Date().toLocaleDateString();
    let minDate = "";

    if (this?.min) minDate = this.min;

    return {
      date: { startDate, endDate: null },
      menu2: false,
      minDate: minDate,
    };
  },
  methods: {
    toggleDialog() {
      this.menu2 = !this.menu2;
    },

    getDateModified() {
      // let startDate, endDate;
      let startDate;
      const pattern = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;

      if (pattern.test(this.date.startDate)) {
        startDate = this.slashSeperatedToISO(this.date.startDate);
      } else {
        startDate = this.extendedToISO(this.date.startDate);
      }
      return startDate;
    },
    slashSeperatedToISO(date) {
      const parts = date.split("/");
      const year = parts[2];
      const month = (parts[0].length == 1 ? "0" : "") + parts[0];
      const day = (parts[1].length == 1 ? "0" : "") + parts[1];
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    extendedToISO(val) {
      const date = new Date(val);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
      // const hours = String(date.getHours()).padStart(2, "0");
      // const minutes = String(date.getMinutes()).padStart(2, "0");
      // const seconds = String(date.getSeconds()).padStart(2, "0");
      // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    clear() {
      this.date = { startDate: null, endDate: null };
    },
    onChangeDateRange() {
      const startDate = this.getDateModified();
      this.$emit("on-date-submit", startDate);
      this.toggleDialog();
    },
  },
};
</script>

<style lang="scss">
.table-condensed {
  // .off {
  //   visibility: hidden;
  // }
  .off.in-range {
    background-color: #ebf4f8 !important;
  }
}

.daterangepicker .drp-calendar td.end-date {
  background-color: rgba(183, 4, 126, 0.8) !important;
}

.calendar-time {
  .form-control {
    padding-left: 11px !important;
  }
}
</style>
